define('app/directives.js',[], function() { 
    var directives = {};
    directives.repeatEnd = function($timeout){
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                if (scope.$last) {
                	$timeout(function() {
	                    var elementHeights = $('.option-label').map(function() {
							return $(this).height();
						}).get();

						// Math.max takes a variable number of arguments
						// `apply` is equivalent to passing each height as an argument
						var maxHeight = Math.max.apply(null, elementHeights);

						// Set each height to the max height
						$('.option-label').height(maxHeight);
					}, 50);
                    $(window).resize(function() {
                        $('.option-label').height('auto');
                        var elementHeights = $('.option-label').map(function() {
							return $(this).height();
						}).get();
						var maxHeight = Math.max.apply(null, elementHeights);
						$('.option-label').height(maxHeight);
                    });
                }
            }
        };
    }

    directives.repeatEnd.$inject = ['$timeout'];

    return directives;
});

